import React from 'react';

import bem from '../../../../utils/bem';

const [, element] = bem('applied-filters-bar');

type AndGroupWrapperProps = {
  children: React.ReactNode;
  showRail: boolean;
};

const AndGroupWrapper: React.FC<AndGroupWrapperProps> = ({ children, showRail }) => (
  <div className={element('and-group', showRail ? 'railed' : undefined)} data-testid="and-group">
    {children}
  </div>
);

export default AndGroupWrapper;
